import { Checkbox, FormControl, ListItemText, MenuItem, Select } from '@mui/material';

const MultiSelectWithCheckbox = ({ label, value, onChange, options }) => {
  const handleChange = (event) => {
    const selectedIds = event.target.value;
    const selectedOptions = options.filter((opt) => selectedIds.includes(opt.id));
    onChange(selectedOptions);
  };

  return (
    <FormControl fullWidth size="small" sx={{ mb: 2 }}>
      <Select
        multiple
        value={value.map((v) => v.id)}
        onChange={handleChange}
        displayEmpty
        renderValue={(selectedIds) => {
          if (selectedIds.length === 0) {
            return `Select ${label.toLowerCase()}`;
          }
          const selectedLabels = options
            .filter((opt) => selectedIds.includes(opt.id))
            .map((opt) => opt.value);
          return selectedLabels.length === 1
            ? selectedLabels[0]
            : `${selectedLabels.length} ${label}(s)`;
        }}>
        {options.map((option) => (
          <MenuItem key={option.id} value={option.id}>
            <Checkbox checked={value.some((v) => v.id === option.id)} />
            <ListItemText primary={option.value} />
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default MultiSelectWithCheckbox;
